<template>
	<v-overlay :value="visible">
		<v-btn class="ms-2" small icon color="white" @click="close">
			<v-icon dark>
				mdi-close
			</v-icon>
		</v-btn>
		<v-img :src="src"></v-img>
	</v-overlay>
</template>

<script>
export default {
	name: 'ImageOverlay',

	props: {
		overlay: {
			type: Boolean,
			default: false,
		},
		src: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			visible: false
		}
	},
	watch: {
		overlay: {
			handler(val) {
				this.visible = val
			}
		}
	},
	mounted() {
		// Keypresses on overlay:
		document.addEventListener('keydown', this.onKeydown)
	},

	beforeDestroy() {
		document.removeEventListener('keydown', this.onKeydown)
	},
	methods: {
		close() {
			this.visible = false
			this.$emit('closed')
		},
		onKeydown(e) {
			if (this.visible) {
				if (e.keyCode == 27) {
					this.close()
				}
			}
		},
	}
}
</script>
